// import React, {useState, useContext, useEffect} from "react";
// import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
// import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
// import AlertContext from "../../../../context/AlertContext";
// import { useParams } from "react-router-dom";
// import Loading from "../../../Notification-Loading/Loading/Loading";
// import { Avatar, Box, Typography } from "@material-ui/core";
// import constants from '../../../../constants';
// import { getDataFromStorage } from "../../../../util";
// import CircularProgress from '@mui/material/CircularProgress';


// const DbLeaderboard = () => {
// const axios = useAxiosPrivate();
// const Alert = useContext(AlertContext);
// const { id } = useParams();
// const {getCatchBlockDetails, getHeaderDetailsForAxios} = useCommonFunctionHooks();
// const [isLoadingTop, setIsLoadingTop] = useState(true);
// const [isLoadingBottom, setIsLoadingBottom] = useState(true);

//  useEffect(()=>{

//    const handleLeaderboardDetail = () => {
  
//     setIsLoadingTop(true);
//     setIsLoadingBottom(true);
//     axios
//       .get(
//        `node/learner/${getDataFromStorage(
//           "learnerid"
//         )}/batch/${id}/leaderboard`,
//         getHeaderDetailsForAxios()
//       )
//       .then((res) => {
//         if (res.data.resultCode === constants.RESULT_STATUS.TECHNICAL_ERROR) {
//           Alert.setShowNotify({
//             show: true,
//             title: "Info",
//             msg: res.data.msg,
//           });
//         } else {         
//             Alert.setLeaderBoardData(res.data.data);
//         }
//       })
//       .catch((error) => {
//         getCatchBlockDetails(error);
//       })
//       .finally(() =>  {
//         setIsLoadingTop(false);
//         setIsLoadingBottom(false);
// });
//   };
//   handleLeaderboardDetail();
//   },[id]);
//  const isArray = Array.isArray(Alert.leaderBoardData);
// const sortedData = Alert.leaderBoardData.data?.sort((a, b) => a.ranking - b.ranking);
// const top4Students = sortedData?.filter(student => student.totalPointsEarned > 0).slice(0, 4);

// const topIds = new Set(top4Students?.map(student => student.id));
// const remainingStudents = sortedData?.filter(student => !topIds.has(student.id));

// const bottom4Students = remainingStudents?.slice(-4);
//     return(

// <div className="leaderBoardDiv">
// <Box className="topScoresContainer">
//   {  isLoadingTop ?(
//     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//   <CircularProgress />
// </div>

// ):(
//     <>
//   <Typography className="topScoresheader">Top Scores</Typography>
// <Box className={
//   Array.isArray(Alert.leaderBoardData?.data) && Alert.leaderBoardData.data.length > 0
//     ? "topscoresdiv"
//     : "topscoresIntialDiv"
// }>

//  {top4Students?.map((student,index) => (

//   <div key={student.id || index} className="topScoresInnerdiv">
//     <span className="topScorerAvatrNamediv">
//       <Avatar src= {student.picture} className="topscoreAvatar"/>

// <Typography className="topScorerName">
//    <span className="topScrorerNameText">{student.name}</span>
//   </Typography>
// </span>
// <Typography className="topscorerPoints">{student.totalPointsEarned}</Typography>
//   </div>

//   ))}
//     </Box>
//     </>)}
// </Box>
// <Box className="topScoresContainer">
//    {isLoadingBottom ?(
//   <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//   <CircularProgress />
// </div>

//    ):( 
//     <>
//   <Typography className="topScoresheader">Underperforming Students</Typography>

// <Box className= {Alert.leaderBoardData?.data?.length >4 ?"topscoresdiv": "topscoresIntialDiv"} >
// {Alert.leaderBoardData?.data?.length >4 &&(
//   <>
//  {bottom4Students?.map((student,index) => (

//   <div key={student.id || index} className="topScoresInnerdiv">
// <span className="topScorerAvatrNamediv">
//       <Avatar src= {student.picture} className="topscoreAvatar"/>

// <Typography className="topScorerName">
//   <span className="topScrorerNameText">{student.name}</span>
//   </Typography>
// </span>
// <Typography className="bottomscorerPoints">{student.totalPointsEarned}</Typography>  
//   </div>
//   ))}
//   </>)
// }
// </Box>
// </>)}
// </Box>


// </div>

//     );
// };
// export default DbLeaderboard; 


import React, { useState, useContext, useEffect } from "react";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import AlertContext from "../../../../context/AlertContext";
import { useParams } from "react-router-dom";
import { Avatar } from "@material-ui/core";
import constants from '../../../../constants';
import { getDataFromStorage } from "../../../../util";
import CircularProgress from '@mui/material/CircularProgress';
import useS3FileManagement from "../../../../Hooks/useS3FileManagement";

const DbLeaderboard = ({setLearners,isLoadingTop,setIsLoadingTop,isLoadingBottom,setIsLoadingBottom}) => {
  const axios = useAxiosPrivate();
  const Alert = useContext(AlertContext);
  const { id } = useParams();
  const { getCatchBlockDetails, getHeaderDetailsForAxios } = useCommonFunctionHooks();
  const { getPreSignedUrl } = useS3FileManagement();


  useEffect(() => {
    Alert.setLeaderBoardData([]);
  },[]);

  useEffect(() => {
    const handleLeaderboardDetail = () => {
      setIsLoadingTop(true);
      setIsLoadingBottom(true);
      axios
        .get(
          `node/learner/${getDataFromStorage(
            "learnerid"
          )}/batch/${id}/leaderboard`,
          getHeaderDetailsForAxios()
        )
        .then(async (res) => {
          if (res.data.resultCode === constants.RESULT_STATUS.TECHNICAL_ERROR) {
            setLearners(res.data.data.learnersTotalCount);
            Alert.setShowNotify({
              show: true,
              title: "Info",
              msg: res.data.msg,
            });
          } else {
            const leaderboardData = res.data.data || {};
            const leaders = leaderboardData.data || [];
            const pictureKeys = leaders
              .map((student) => student?.picture)
              .filter(Boolean);

            let leaderboardWithPictures = leaders;
            if (pictureKeys.length > 0) {
              const presignedResponse = await getPreSignedUrl(
                pictureKeys,
                undefined,
                "",
                "GET"
              );
              const presignedUrls = presignedResponse?.url || [];
              const urlByPictureKey = pictureKeys.reduce((acc, key, index) => {
                acc[key] = presignedUrls[index];
                return acc;
              }, {});

              leaderboardWithPictures = leaders.map((student) => ({
                ...student,
                picture: urlByPictureKey[student?.picture] || student?.picture,
              }));
            }
            Alert.setLeaderBoardData({
              ...leaderboardData,
              data: leaderboardWithPictures,
            });
            setLearners(res.data.data.learnersTotalCount);
          }
        })
        .catch((error) => {
          getCatchBlockDetails(error);
        })
        .finally(() => {
          setIsLoadingTop(false);
          setIsLoadingBottom(false);
        });
    };
    handleLeaderboardDetail();
  }, [id]);

  const sortedData = Alert.leaderBoardData.data?.sort((a, b) => a.ranking - b.ranking);
  const top4Students = sortedData?.filter(student => student.totalPointsEarned > 0).slice(0, 4);
  const topIds = new Set(top4Students?.map(student => student.id));
  const remainingStudents = sortedData?.filter(student => !topIds.has(student.id));
  const allStudents = Alert.leaderBoardData?.data || [];

const bottom4Students = sortedData
  ?.filter(student => !topIds.has(student.id))
  .slice(-4);

const zeroPointStudents = allStudents.length <= 4
  ? allStudents.filter(student => student.totalPointsEarned === 0)
  : [];


  return (
    <div className="leaderboard-container">
      <div className="scores-section">
        {isLoadingTop ? (
          <div className="loading-container">
            <CircularProgress />
          </div>
        ) : (
          <>
            <span className="section-header">Top Scores</span>
            <div className={
              Array.isArray(Alert.leaderBoardData?.data) && Alert.leaderBoardData.data.length > 0
                ? "scores-list"
                : "scores-list-empty"
            }>
              {top4Students?.map((student, index) => (
                <div key={student.id || index} className="student-score-item">
                  <div className="student-info">
                    <Avatar src={student.picture} className="student-avatar" />
                      <span className="name-text" title={student.name}>{student.name}</span>
                  </div>
                  <div className="score top-score">{student.totalPointsEarned}</div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      <div className="scores-section">
        {isLoadingBottom ? (
          <div className="loading-container">
            <CircularProgress />
          </div>
        ) : (
          <>
            <span className="section-header">Underperforming Students</span>
            <div className={(Alert.leaderBoardData?.data?.length > 4 || zeroPointStudents.length > 0) ? "scores-list" : "scores-list-empty"}>
              {((Alert.leaderBoardData?.data?.length > 4 ? bottom4Students:zeroPointStudents).sort((a, b) => a.totalPointsEarned - b.totalPointsEarned)
                    ?.map((student, index) => (
                      <div key={student.id || index} className="student-score-item">
                        <div className="student-info">
                          <Avatar src={student.picture} className="student-avatar" />
                            {/* <span className="name-text">{student.name}</span> */}
                            <span className="name-text" title={student.name}>
                            {student.name}
                             </span>
                        </div>
                        <div className="score bottom-score">{student.totalPointsEarned}</div>
                      </div>
                    ))
               
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DbLeaderboard;
